import React from 'react';

import {FormControl, FormControlLabel, FormGroup, FormLabel, Switch as MuiSwitch,} from '@mui/material';

import {Field} from 'react-final-form';
import {ErrorMessage, showErrorOnChange, useFieldForErrors} from './utils';
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        width: props => props.fullWidth ? '100%' : 'auto',
        justifyContent: 'space-around',
        alignItems: 'center',
    }
}))

const Switches = (props) => {
    const {
        name,
        data,
        label,
        required,
        helperText,
        fieldProps,
        formControlProps,
        formGroupProps,
        formLabelProps,
        formControlLabelProps,
        formHelperTextProps,
        fullWidth,
        showError = showErrorOnChange,
        ...restSwitches
    } = props;

    const classes = useStyles({fullWidth: fullWidth});
    const itemsData = !Array.isArray(data) ? [data] : data;
    const single = itemsData.length === 1;
    const field = useFieldForErrors(name);
    const isError = showError(field);

    return (
        <FormControl className={classes.root} required={required} error={isError} {...formControlProps}>
            {label ? <FormLabel {...formLabelProps}>{label}</FormLabel> : <></>}
            <FormGroup {...formGroupProps}>
                {itemsData.map((item, idx) => (
                    <FormControlLabel
                        key={idx}
                        name={name}
                        label={item.label}
                        value={single ? undefined : item.value}
                        disabled={item.disabled}
                        control={
                            <Field
                                type="checkbox"
                                name={name}
                                render={({input: {name, value, onChange, checked, ...restInput}}) => (
                                    <MuiSwitch
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        checked={checked}
                                        disabled={item.disabled}
                                        required={required}
                                        inputProps={{required, ...restInput}}
                                        {...restSwitches}
                                    />
                                )}
                                {...fieldProps}
                            />
                        }
                        {...formControlLabelProps}
                    />
                ))}
            </FormGroup>
            <ErrorMessage
                showError={isError}
                meta={field.meta}
                formHelperTextProps={formHelperTextProps}
                helperText={helperText}
            />
        </FormControl>
    );
}
export default Switches;
